import { uiDataActions } from "./uiData-slice";
import { fetchStaticJson } from "../../utils/utils";
import { logError } from "../../errors/logError";
import { entitiesActions } from "./entities-slice";
import entitysType from "../../enums/entitysType";

export const getMetaData = () => {
    return async (dispatch) => {
        if (!window.config.metaData) {
            logError({ type: "fetch-json", error: "metaData json is empty in config null", desc: `metaData json is empty, try fetch ${window.config.metaData}`, props: { config: JSON.stringify(window.config) } });
        }
        const metaData = await fetchStaticJson(window.config.metaData)
        if (metaData)
            dispatch(uiDataActions.initMetaDataData(metaData));
        else
            logError({ type: "fetch-json", error: "metaData json is empty", desc: `metaData json is empty, try fetch ${window.config.metaData}` });
    }
}

export const getGeneral = () => {
    return async (dispatch) => {
        try {
            let res = await fetchStaticJson(window.config.general)
            if (res) {
                dispatch(uiDataActions?.initGeneral(res));
            }
        }
        catch (e) {

        }
    }
}

export const fetchUsefulTools = () => {
    return async (dispatch) => {
        try {
            const usefulTools = await fetchStaticJson(window.config.usefulTools);
            if (usefulTools) {
                // dispatch(uiDataActions.initUsefulTools(usefulTools));
                dispatch(entitiesActions.addEntities([...(usefulTools?.map(t => ({ ...t, type: entitysType.usefulTool })))]));
            }
        } catch (e) {
            console.log("error fetching useful tools", e);
        }
    }
}
export const fetchPermissionList = () => {
    return async (dispatch) => {
        try {
            const permissionLlist = await fetchStaticJson(window.config.permissionLlist);
            if (permissionLlist) {
                dispatch(uiDataActions.initFinalProjectStudents(permissionLlist));
            }
        } catch (e) {
            console.log("error fetching final project students", e);
        }
    }
}

export const fetchPermissionFilters = () => {
    return async (dispatch) => {
        try {
            const permissionFilters = await fetchStaticJson(window.config.permissionFilters);
            if (permissionFilters) {
                dispatch(uiDataActions.initPermissionFilters(permissionFilters));
            }
        } catch (e) {
            console.log("error fetching permission filters", e);
        }
    }
}

export const fetchShortcut = () => {
    return async (dispatch) => {
        try {
            const shortcut = await fetchStaticJson(window.config.shortcut);
            if (shortcut) {
                // dispatch(uiDataActions.initShortcut(shortcut));
                dispatch(entitiesActions.addEntities([...(shortcut?.map(t => ({ ...t, type: "shortcut" })))]))
            }
        } catch (e) {
            console.log("error fetching useful tools", e);
        }
    }
}

export const getHomeData = () => {
    return async (dispatch) => {
        try {
            const homeData = await fetchStaticJson(window.config.homeData);
            if (homeData) {
                dispatch(uiDataActions.initHome(homeData));
            }
        } catch (e) {
            console.log("error fetching home data", e);
        }
    }
}

export const fetchTeachingAssistantBots = () => {
    return async (dispatch) => {
        try {
            const teachingAssistantBots = await fetchStaticJson(window.config.teachingAssistantBot);
            if (teachingAssistantBots) {
                dispatch(entitiesActions.addEntities(teachingAssistantBots.map(bot => ({ ...bot, type: entitysType.bot }))));
            }
        } catch (e) {
            console.log("error fetching teaching assistant bots", e);
        }
    }
}